module.exports = "<p>You are leaving the BRCA Exchange Summary View and entering the portal to view all public variant data. This portal contains a much larger set of variant data than the Summary View, and includes variant interpretations that have not yet been subject to expert review by the ENIGMA consortium. Pathogenicity assignments are from the original submitters.</p><p>Are you sure you want to leave the Summary View to view all public variant data?</p>";


//////////////////
// WEBPACK FOOTER
// ./content/researchWarning.md
// module id = 1283
// module chunks = 0